














import Vue from 'vue';

export default Vue.extend({
    props: ['tabs', 'tabAcive', 'url'],
    data() {
        return {

        }
    },
    methods: {

    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/Tabs.vue